import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Input, Card, message, Select, Spin, Icon, Tag } from "antd";
import Cookies from "js-cookie";
import axios from "axios";
import { withRouter } from "react-router-dom";
import CustomAgGridTable from "../../../Common-Table/CustomAgGridTable";
import F from "../../../Functions";

// store 
import { useBoundStore } from "../../../store/useBoundStore";

// assets imports
import RefreshIcon from "../../../assets/refresh-icon.png";
import ActionButtonsRenderer from "./ActionButtonsRenderer";
import { GET_ROLES_API, INVITED_LOAD_USERS_API_URL } from "../../../utils/Api_enums";
import Pagination from "../../../components/pagination";
import { debounceQuery, TYPE_OF_CALL, TYPE_OF_ROLES, TYPE_TO_FILTER_BY_EMAIL, TYPE_TO_FILTER_BY_FIRST_NAME, TYPE_TO_FILTER_BY_LAST_NAME, USER_TYPE_DROPDOWN } from "../../../utils/Constants";
import CustomHeader from "../../../CommonHeader/CustomHeader";
import "../ManageSchedulers/ManageScheduler.css";
import { Translate } from "react-translated";


const { Search } = Input;
const { Option } = Select;


export const BUTTON_CONSTANTS = {
  resend: { label: "Resend", key: "resend" },
  delete: { label: "Delete", key: "delete" },
};

const InvitedScheduler = (props) => {
  const debounceRef = useRef(null);

  // sidebar usertype
  const { userType } = useBoundStore((state) => ({
    userType: state.userType,
  }));

  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);

  const { location } = props;
  const [invitedState, setInvitedState] = useState({
    loading: true,
    users: [],
    user: {},
    tableData: [],
    selectedUserType: [],
    searchText: "",
    filterColumnValue: "",
    filterColumnField: "",
  });
  const [currentState, setCurrentState] = useState({
    page: 1,
    total_pages: 0,
  });
  const [roles, setRoles] = useState([]);

  // ----
  const [sortOrders, setSortOrders] = useState({});
  // state for localefield
  const [localField, setLocalField] = useState("updated_on");
  // state for localorder
  const [localOrder, setLocalOrder] = useState("desc")
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const wrapperRef = useRef(null);
  const selectRef = useRef(null);

  // --- Filter popover reset logic ---
  const resetHandlers = useRef([]);
  const handleFilterResetHandler = (resetFn) => {
    resetHandlers.current.push(resetFn);
  };


  const handleSort = (field) => {
    let newOrder;
    setSortOrders((prev) => {
      const currentOrder = prev[field] || "asc";
      newOrder = currentOrder === "asc" ? "desc" : "asc";
      return { ...prev, [field]: newOrder };
    });
    setLocalOrder(newOrder);
    setLocalField(field);
  };

  const getTypeOFCall = (user) => {
    const roles = user.roles;
    if (roles.length > 0) {
      const updatedRoles = roles.map((role) => TYPE_OF_CALL[role.rolename]);
      // console.log("updatedRoles",updatedRoles)
      return updatedRoles.join(",")
    }
    return ""
  }


  // table button action methods based on which button is clicked
  const handleButtonClick = (buttonType, data) => {
    // console.log("Button clicked:", buttonType);
    if (buttonType === BUTTON_CONSTANTS.resend.key) {
      resend(data.id, data.email);
    } else if (buttonType === BUTTON_CONSTANTS.delete.key) {
      deleteFunc(data.id);
    }
  };


  const CustomTooltip = (props) => {
    return (
      <div style={{
        background: "rgba(0, 0, 0, 0.8)",
        color: "white",
        padding: "8px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        maxWidth: "200px",
        textAlign: "center"
      }}>
        {props.value}
      </div>
    );
  };

  const searchTimeout = useRef(null);

  const handleFilter = (field, value) => {
    setCurrentState(prev => ({
      ...prev,
      filterColumnValue: null,
      filterColumnField: null,
    }));

    if (field === 'type_of_Call') {
      setInvitedState(prev => ({
        ...prev,
        selectedUserType: value,
      }));
    } else {
      setInvitedState(prev => ({
        ...prev,
        filterColumnValue: value,
        filterColumnField: field,
      }));
      // setCurrentState(prev => ({
      //   ...prev,
      //   page: 1
      // }))
    }

    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      loadUsers(1);
    }, 500);
  };


  const coleDef = [
    {
      headerClass: 'custom-ag-header',
      headerName: "First Name",
      valueGetter: (params) => `${params.data.first_name || ""}`,
      sortable: true,
      headerComponent: CustomHeader,
      sortOrder: sortOrders["first_name"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["First Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "first_name",
        sortOrder: sortOrders["first_name"],
        handleSort,
        handleFilter,
        showPopOver: true,
        inputType: "text",
        handleFilterResetHandler,
        placeholder: TYPE_TO_FILTER_BY_FIRST_NAME,
        defaultFilterContentWidth: 180,
      }),
      colId: 'first_name',
      tooltipComponent: CustomTooltip,

    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Last Name",
      valueGetter: (params) => `${params.data.last_name || ""}`,
      sortable: true,
      // filter: true,
      headerComponent: CustomHeader,
      sortOrder: sortOrders["last_name"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Last Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "last_name",
        sortOrder: sortOrders["last_name"],
        handleSort,
        handleFilter,
        showPopOver: true,
        inputType: "text",
        handleFilterResetHandler,
        placeholder: TYPE_TO_FILTER_BY_LAST_NAME,
      }),
      colId: 'last_name',
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Email",
      field: "email",
      sortable: true,
      // filter: true,
      width: 400,
      headerComponent: CustomHeader,
      sortOrder: sortOrders["email"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Email"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "email",
        sortOrder: sortOrders["email"],
        handleSort,
        handleFilter,
        showPopOver: true,
        inputType: "text",
        handleFilterResetHandler,
        placeholder: TYPE_TO_FILTER_BY_EMAIL,
      }),
      colId: 'email',
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "User Type",
      field: "user_type",
      sortable: false,
      filter: false,
      headerComponentParams: (params) => ({
        headers: ["User Type"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "user_type",
        handleFilter,
        showPopOver: true,
        inputType: "select",
        options: F.getUserType(),
        handleFilterResetHandler
      }),
      colId: 'user_type',
      headerComponent: CustomHeader,
      cellRendererFramework: (params) => {
        const userType = params.value;
        let displayUserType = params.value;

        if (userType === "REVIEWSCHEDULER") {
          displayUserType = "RS";
        } else if (userType === "LSP") {
          displayUserType = "LSP";
        } else if (userType === "VONBOARDER") {
          displayUserType = "FS";
        } else if (userType === "VONSCHEDULER") {
          displayUserType = "RFS";
        }

        return (
          <div>
            <span
              style={{
                backgroundColor: "rgba(22, 72, 151, 0.12)",
                color: "#000",
                padding: "5px 5px",
                borderRadius: "7px",
              }}
            >
              {/* {params.value} */}
              {displayUserType}
            </span>
          </div>
        );
      },
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Type of Call",
      field: "type_of_Call",
      sortable: false,
      filter: false,
      width: 210,
      headerComponentParams: (params) => ({
        headers: ["Type of Call"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "type_of_Call",
        handleFilter,
        showPopOver: true,
        inputType: "multiCheckbox",
        options: F.getTypeOFCall(),
        handleFilterResetHandler
      }),
      colId: 'type_of_Call',
      headerComponent: CustomHeader,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Actions",
      sortable: false,
      filter: false,
      cellRendererFramework: ActionButtonsRenderer,
      width: 450,
      cellRendererParams: {
        onButtonClick: (buttonType, data) =>
          handleButtonClick(buttonType, data), // Pass as callback
        invitedState,
      },
    },
  ];


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [])


  useEffect(() => {
    const getRoles = async () => {
      const { data: { roles } } = await axios.get(GET_ROLES_API);
      setRoles(roles.map(item => {
        return {
          label: TYPE_OF_CALL[item.rolename],
          value: TYPE_OF_CALL[item.rolename],
          role_id: item.role_id,
          // checked:false, 
        }
      }))
    }
    getRoles();
  }, [])


  const loadUsers = async (page) => {

    const nPage = page === undefined ? 1 : page;
    const filterColumnValue = invitedState && invitedState.filterColumnValue && invitedState.filterColumnValue.trim();
    const filterColumnField = invitedState && invitedState.filterColumnField && invitedState.filterColumnField.trim();
    let url = `${INVITED_LOAD_USERS_API_URL}?page=${nPage}&sort_by=${localField}&sort_order=${localOrder}`;
    if (invitedState.selectedUserType.length > 0) {
      url += `&role_filter=${TYPE_OF_ROLES(invitedState.selectedUserType)}`;
    }

    if (filterColumnValue && filterColumnField) {
      const filterObj = {};
      filterObj[filterColumnField.toLowerCase()] = filterColumnValue;
      url += `&filter_by_column_name=${encodeURIComponent(JSON.stringify(filterObj))}`;
    }

    if (invitedState.searchText) {
      url += `&search_word=${encodeURIComponent(invitedState.searchText)}`;
    }



    try {
      setInvitedState((prevState) => ({ ...prevState, loading: true }));
      const res = await axios.get(url);
      const users = res.data.invited_users;
      // console.log("res invited schedulers",res)
      // console.log("users invited ",users)
      const table_data = users.map((user) => ({
        key: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        ...user,
        type_of_Call: getTypeOFCall(user),
      }));
      setInvitedState((prevState) => ({
        ...prevState,
        tableData: table_data,
      }));
      setCurrentState((prevState) => ({
        ...prevState,
        page: res.data.page,
        total_pages: res.data.total_pages,
      }));


    } catch (error) {
      console.log(error);

    } finally {
      setInvitedState((prevState) => ({ ...prevState, loading: false }));
    }



    // axios.get(url).then((res) => {
    //   const users = res.data.results;
    //   const data = [];
    //   // this.setState({ loading: false, users: Array.isArray(users) ? users:[] });
    //   for (let i = 0; i < users.length; i++) {
    //     let user = users[i];

    //     data.push({
    //       key: i,
    //       first_name: user.first_name,
    //       last_name: user.last_name,
    //       email: user.email,
    //       ...user,
    //       type_of_Call: getTypeOFCall(user),
    //     });
    //   }
    //   setInvitedState((prevState) => ({
    //     ...prevState,
    //     loading: false,
    //     users: Array.isArray(users) ? users : [],
    //     tableData: data,
    //   }));
    // }).catch((err) => {
    //   this.setState({ loading: false });
    //   console.log("err",err)
    //   setInvitedState((prevState) => ({ ...prevState, loading: false }));
    //   // message.error(F.translate(`Error loading users.`));
    // }).finally(() => {
    //     setInvitedState((prevState) => ({ ...prevState, loading: false }));
    // });
  };

  const resend = (id, email) => {
    // console.log("resend", id, email);
    // this.setState({ loading: true });
    setInvitedState((prevState) => ({ ...prevState, loading: true }));
    axios
      .get("/api/reinvite/" + id)
      .then(() => {
        // this.setState({ loading: false });
        setInvitedState((prevState) => ({ ...prevState, loading: false }));
        message.success(
          "Your invitation request has been successfully sent to " + email
        );
      })
      .catch(() => {
        // this.setState({ loading: false });
        setInvitedState((prevState) => ({ ...prevState, loading: false }));
        message.error(F.translate(`Invite not sent.`));
      });
  };

  const deleteFunc = (id) => {
    // this.setState({ loading: true });
    setInvitedState((prevState) => ({ ...prevState, loading: true }));
    axios
      .put("/api/users/" + id, {
        registration_token: null,
      })
      .then(() => {
        message.success(
          F.translate(`The invitation request has been removed.`)
        );
        // this.setState({ loading: false }, () => {
        //     this.loadUsers(1);
        // });
        setInvitedState((prevState) => ({ ...prevState, loading: false }));
        loadUsers(1);
      })
      .catch(() => {
        // this.setState({ loading: false });
        setInvitedState((prevState) => ({ ...prevState, loading: false }));
        message.error(F.translate(`Invite not removed.`));
      });
  };

  const refreshInfo = () => {
    resetHandlers.current.forEach(reset => reset());
    setInvitedState((prevState) => ({
      ...prevState,
      searchText: "",
      selectedUserType: [],
      filterColumnValue: "",
      filterColumnField: "",
    }));
    localStorage.removeItem("agGridColumnState");

    if (gridColumnApi) {
      gridColumnApi.resetColumnState();
      gridColumnApi.resetColumnGroupState();
    }

    loadUsers(1);
  }



  useEffect(() => {
    clearTimeout(debounceRef.current);

    const hasGlobalSearch = invitedState && invitedState.searchText &&
      invitedState.searchText.trim() !== "";
    const hasColumnFilter =
      (invitedState && invitedState.filterColumnField && invitedState.filterColumnField.trim() !== "") &&
      (invitedState && invitedState.filterColumnValue && invitedState.filterColumnValue.trim() !== "");

    debounceRef.current = setTimeout(() => {
      if (hasGlobalSearch || hasColumnFilter) {
        debounceQuery(() => loadUsers(invitedState.page || 1), 500);
      } else {
        loadUsers(invitedState.page || 1);
      }
    }, 500);

    return () => {
      clearTimeout(debounceRef.current);
    };
  }, [
    invitedState.page,
    localField,
    localOrder,
    invitedState.searchText,
    invitedState.filterColumnField,
    invitedState.filterColumnValue,
    invitedState.selectedUserType,
  ]);



  const handleSearch = (e) => {
    const { value } = e.target;
    setInvitedState((prevState) => ({
      ...prevState,
      searchText: value,
    }));
    // debounceQuery(() => loadUsers(1), 500);
  }


  const customTagRender = (props) => {
    const { label, value, closable, onClose } = props;
    return (
      <Tag closable={closable} onClose={onClose}>
        {value}
      </Tag>
    );
  };




  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }, []);

  const saveState = useCallback((params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }, []);


  return (
    <div>
      <div>
        {/* Manage Schedulers header  */}
        <div className="manage-scheduler-header-container">
          <div>
            <Icon style={{ marginRight: 10, color: "#1890ff" }} type="usergroup-add" />
            <span style={{ fontWeight: '600' }}>
              <Translate text="Invited Schedulers" />
            </span>
          </div>

          <div className="input-container manage-scheduler-input-container">
            {/* Search Input */}
            <div style={{ position: "relative" }} className="manage-scheduler-input-container" >
              <Input
                placeholder=" Search by Name "
                value={invitedState.searchText}
                style={{ minWidth: 200 }}
                className="searchinput borderRadius-28  "
                onChange={(e) => handleSearch(e)}
              />
              {invitedState.searchText ? (
                <Icon
                  type="close"
                  onClick={() => handleSearch({ target: { value: "" } })}
                  className="icon-style right-10"

                />
              ) : (
                <Icon
                  type="search"
                  className="icon-style right-10"
                />
              )}
            </div>



            {/* Select Dropdown */}
            <div ref={wrapperRef} className="select-dropdown-container" >
              <Select
                ref={selectRef}
                open={dropdownOpen}
                onDropdownVisibleChange={(open) => setDropdownOpen(open)}
                // allowClear
                mode="multiple"
                value={invitedState.selectedUserType}
                placeholder="Select Type of Call"
                maxTagCount={1}
                onChange={(value) => {
                  setInvitedState((prevState) => ({
                    ...prevState,
                    selectedUserType: value
                  }))
                  // setInvitedScheduler({userType: value})
                }}
                style={{
                  // width: 200,
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  fontSize: "12px"
                  // border:"1px solid #cfc9c9"
                }}
                className="searchinput user_type_select manage-scheduler-searchinput "
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                tagRender={customTagRender}
                optionLabelProp="value"
              >
                {
                  roles.map((option) => (
                    <Option key={option.role_id} value={option.value}>{option.label}</Option>
                  ))
                }
              </Select>
              <Icon
                type={dropdownOpen ? "up" : "down"}
                className="icon-style right-15"
                onClick={() => setDropdownOpen((prev) => !prev)}
              />
            </div>



            <Button
              style={{
                marginTop: "0px",
              }}
              type='primary'
              className="bg-164897 borderRadius-28 myrefresh-btn"
              onClick={refreshInfo}
            >
              <Icon type="reload" />
              Refresh
            </Button>
          </div>
        </div>

        {/* Manage Schedulers Table  */}
        <div>
          <Spin spinning={invitedState.loading}>

            {coleDef.length > 0 && Array.isArray(invitedState.tableData) ? (
              <CustomAgGridTable
                onGridReady={onGridReady}
                onColumnMoved={saveState}
                onSortChanged={saveState}
                onFilterChanged={saveState}
                rowDatas={invitedState.tableData}
                columnDefss={coleDef}
              />
            ) : (
              <p>Loading...</p>
            )}
          </Spin>
        </div>
        <div className="pagination-div-container">
          <Pagination
            className="pagination-container"
            current_page={currentState.page}
            total_pages={currentState.total_pages}
            onClick={(page) => {
              loadUsers(page)
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default withRouter(InvitedScheduler);



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/Invited Schedulers/InvitedScheduler.js